module.exports = __webpack_public_path__ + "img/minions1.jpg";